<template>
  <div class="row" style="height: 95%; overflow: hidden">
    <div class="col-md-12 py-1 px-3" style="height: 100%; overflow: hidden">
      <input
        type="text"
        class="form-control"
        v-model="search"
        placeholder="Buscar"
      />
      <load v-if="load" mode="table" class="mt-3" />
      <div style="height: 70vh; overflow: auto" class="mt-2" v-else>
        <!--Contact Selected-->
        <ContactList
          v-if="selected && selected.unidade_id == unidadeid"
          :contact="selected"
          :users="userOnline"
          @selected="selectContact(selected)"
          :selected="true"
        />
        <!--Contact Online-->
        <ul
          class="list-group list-group-flush"
          style="list-style: none; max-height: 90%; overflow: auto"
          v-if="search == ''"
        >
          <!-- <li class=""> -->
          <ContactList
            v-for="contact in contactsOnline"
            :key="contact.id"
            @selected="selectContact(contact)"
            :contact="contact"
            :online="true"
          />
          <!-- </li> -->
        </ul>
        <!--Contact Offline-->
        <ul class="list-group list-group-flush" v-if="search == ''">
          <!-- style="list-style: none; max-height: 90%; overflow: auto" -->

          <ContactList
            v-for="(contactoff, off) in contactsOffline"
            :key="off"
            @selected="selectContact(contactoff)"
            :contact="contactoff"
            :online="false"
          />
        </ul>
        <ul class="list-group list-group-flush" v-if="search != ''">
          <!-- <li
						
						class=""
					> -->
          <ContactList
            v-for="contact in filterContacts"
            :key="contact.id"
            @selected="selectContact(contact)"
            :contact="contact"
          />
          <!-- </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ContactList from "./includes/ContactList";
export default {
  components: { ContactList },
  props: {
    contacts: {
      type: Array,
      default: [],
    },
    load: { type: Boolean, default: true },
  },
  data() {
    return {
      selected: [],
      search: "",
      loadContact: true,
      unidadeid: "",
    };
  },
  methods: {
    checkUserOnline(user) {
      var online = this.$store.state.users.filter((u) => {
        if (
          (user.id == u.id || user.id == u.userID) &&
          u.unidadeID == this.unidadeid
        ) {
          return u;
        }
      });
      return online[0] > 0 ? true : false;
    },
    selectContact(contact) {
      this.selected = contact;
      this.search = "";
      localStorage.setItem("user-chat-selected", JSON.stringify(contact));

      this.$emit("selected", contact);
    },
  },
  mounted() {
    this.unidadeid = localStorage.getItem("unidade-chat-selected");

    var user_save = localStorage.getItem("user-chat-selected");

    if (user_save) {
      this.selected = JSON.parse(user_save);
    }

    if (this.selected && this.unidadeid != this.selected.unidade_id) {
      localStorage.removeItem("user-chat-selected");
      this.selecte = [];
    }
  },
  computed: {
    contactsOnline() {
      return this.sortedContacts.filter((contact) => {
        var online = this.$store.state.users.filter((u) => {
          if (
            (contact.id == u.id || contact.id == u.userID) &&
            u.unidadeID == this.unidadeid
          ) {
            return u;
          }
        });

        var is_online = online[0] ? true : false;

        if (is_online && this.selected && contact.id != this.selected.id) {
          return contact;
        }
      });
    },
    contactsOffline() {
      return this.sortedContacts.filter((contact) => {
        var online = this.$store.state.users.filter((u) => {
          if (
            (contact.id == u.id || contact.id == u.userID) &&
            u.unidadeID == this.unidadeid
          ) {
            return u;
          }
        });

        var is_online = online[0] ? true : false;

        if (!is_online && this.selected && contact.id != this.selected.id) {
          return contact;
        }
      });
    },
    sortedContacts() {
      let sort = this.contacts.sort();
      return _.sortBy(this.contacts, "name", [
        (contact) => {
          if (contact.unread) {
            return Infinity;
          }
        },
      ]);

      // return _.sortBy(this.contacts, [
      //     (contact) => {
      //         if (contact) {
      //             // if (this.selected && contact.id == this.selected.id) {
      //             //     return Infinity;
      //             // }

      //             return contact.unread;
      //         }
      //     },
      // ]).reverse();
    },
    filterContacts: function () {
      return this.sortedContacts.filter((contact) => {
        return contact.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    userOnline() {
      return this.$store.state.users;
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
  background-color: #f4f4f4;
}
::-webkit-scrollbar {
  width: 5px;
  background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 25em;
}
.unread {
  background: #fb8994;
  color: #fff;
  right: 11px;
  min-width: 20px;
  /* top: 20px; */
  align-items: center;
  line-height: 20px;
  font-size: 12px;
  padding: 0 4px;
  /* float: right; */
  z-index: 1010;
  /* position: absolute; */
  text-align: center;
  border-radius: 10px;
}
.contacts-list {
  flex: 2;
  height: 58vh;
  overflow: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact:hover {
  color: #0d5a9e;
}
.availability-status {
  font-size: 8px;
}
.availability-status.online {
  color: #1bcfb4;
}
.availability-status .offline {
  background: #ccc;
}
.user-list {
  /* min-height: 50px; */
  border-bottom: 1px solid #eaeaea;
}
.user-list:hover {
  cursor: pointer;
  background: #f4f4f4;
}
</style>
